<template>
    <b-container class="my-3">
        <page-show :alias="'apply'"></page-show>  
        <mail-form type="Обратиться за рассрочкой"></mail-form> 
    </b-container>
</template>

<script>
import PageShow from "@/components/components/PageShow";
import MailForm from "@/components/components/MailForm";
export default {
    components:{
        'page-show':PageShow,
        'mail-form':MailForm
    }
}
</script>

<style lang="scss">

</style>